import { render, staticRenderFns } from "./ComissoesForm.vue?vue&type=template&id=f65492d2&scoped=true&"
import script from "./ComissoesForm.vue?vue&type=script&lang=js&"
export * from "./ComissoesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65492d2",
  null
  
)

export default component.exports